export default __webpack_public_path__ + "static/SRUS SC105 - Especification Del Producto y Datos Técnicos-0c06336ed46782f22d38afd9ea730e6c.pdf";